
// src/web/components/reported-date-picker.jsx

import React from 'react'
import ui from '../../helpers/ui-state'
import { translate } from 'react-i18next'
import {
  DatePickerDialog,
} from 'react-toolbox/lib/date_picker'
import {
  Button,
} from 'react-toolbox/lib/button'
import DiaryUploadFiles from './diary-upload-files.jsx'
import RithTextEditor from './rich-text-editor.jsx'
import moment from 'moment'
import reportedDatePickerTheme from './themes/reported-date-picker.css'

const locale = {
  months: moment.months(),
  monthsShort: moment.monthsShort(),
  weekdays: moment.weekdays(),
  weekdaysShort: moment.weekdaysShort(),
  weekdaysLetter: moment.weekdaysShort(),
}

function ReportedDatePicker(props) {
  const {
    t,
    ui,
    date,
    onChangeDate,
    category,
    updateUI,
  } = props

  return (
    <div>
      <Button flat className={reportedDatePickerTheme.label}
          onClick={()=> updateUI({ active: true })}
          label={t('format:diary_subject', { reported_at: date, category: t('diary:' + category) })} />
      <DatePickerDialog active={ui.active}
          theme={reportedDatePickerTheme}
          autoOk={true}
          okLabel={t('label:了解')}
          cancelLabel={t('label:取り消し')}
          locale={locale}
          value={date}
          sundayFirstDayOfWeek={true}
          onEscKeyDoan={()=> updateUI({ active: false })}
          onOverlayClick={()=> updateUI({ active: false })}
          onSelect={(_date)=> { updateUI({ active: false }); onChangeDate(_date) }}
          onDismiss={()=> updateUI({ active: false })} />
    </div>
  )
}

export default translate()(ui({ state: { active: false }})(ReportedDatePicker))



// WEBPACK FOOTER //
// ./src/web/components/reported-date-picker.jsx